import { useState } from 'react';
import '../Styles/CategoryStyles.css';
import ItemCategoryList from '../statefull/ManageItemCategory/ItemCategoryList';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ManageItemCategory = () => {
  const { t } = useTranslation();
  const [mode, setMode] = useState<'add' | 'edit'>('add');
  const [modal, setModal] = useState(false);

  const handleEditCategory = () => {
    setMode('edit');
  };


  return (
      <>
        <Typography variant="h5" fontWeight="bold" mb={2}>
          {t('itemCategory.title')}
        </Typography>
        <ItemCategoryList
          editCategory={handleEditCategory}
          mode={mode}
          modal={modal}
          setModal={setModal}
          setMode={setMode}
        />
      </>
  );
};

export default ManageItemCategory;
